import "./LandingStyle.css";
import { TypeAnimation } from "react-type-animation";

import Button from "../../SubComponents/Button/Button";
export default function Landing() {
  return (
    <div className="landing-page" data-aos="fade-up">
      <p className="heading-one">Hi, my name is </p>
      <div className="heading-two">
        <p>Kanika Rajpal</p>
      </div>
      <p className="heading-three">
        <TypeAnimation
          sequence={[
            "I build things for the web world🌐",
            2000, // Waits 2s
            "I build things for the web world 🖧",
            2000, // Waits 2s
            "I build things for the web world 💻",
            2000, // Waits 2s
          ]}
          wrapper="span"
          cursor={true}
          repeat={Infinity}
        />
      </p>
      <p className="heading-four">
        Ahoy there! I'm a computer science engineering student who's all about
        writing clean code & bringing innovative ideas to life. With a knack for
        productivity & a love for learning, I'm always seeking out new
        challenges & exciting opportunities. Care to join me on this journey of
        exploration & creativity?{" "}
      </p>
      <div className="btn-section">
        <Button>
          <a href="#about" className="link">
            Click here to know more about me !
          </a>
        </Button>
      </div>
    </div>
  );
}
